const navigationGuardKey = 'asbplayerMouseNavigationGuard';
let navigationGuardUsers = 0;

function armNavigationGuard() {
    if (window.history.state?.[navigationGuardKey]) return;
    // Some browsers navigate with side buttons even after preventDefault.
    window.history.pushState({ ...window.history.state, [navigationGuardKey]: true }, '', window.location.href);
}

export function retainMouseNavigationGuard() {
    if (navigationGuardUsers++ === 0) window.addEventListener('popstate', armNavigationGuard);
    armNavigationGuard();
    return () => {
        if (--navigationGuardUsers === 0) window.removeEventListener('popstate', armNavigationGuard);
    };
}

export function mouseShortcut(event: MouseEvent): string | undefined {
    if (event.button !== 3 && event.button !== 4) return undefined;
    return [
        event.ctrlKey && 'ctrl',
        event.altKey && 'alt',
        event.shiftKey && 'shift',
        event.metaKey && 'command',
        `Mouse${event.button}`,
    ]
        .filter(Boolean)
        .join('+');
}

export function isMouseShortcut(shortcut: string): boolean {
    return /(?:^|\+)Mouse[34]$/i.test(shortcut);
}

export function bindMouseShortcut(shortcut: string, capture: boolean, handler: (event: MouseEvent) => boolean) {
    const releaseGuard = retainMouseNavigationGuard();
    const normalizedShortcut = shortcut.toLowerCase().split('+').sort().join('+');
    const button = Number(shortcut.at(-1));
    let pressed = false;
    const onMouseDown = (event: MouseEvent) => {
        pressed = mouseShortcut(event)?.toLowerCase().split('+').sort().join('+') === normalizedShortcut;
        if (!pressed) return;
        event.preventDefault();
        const target = event.target;
        if (target instanceof HTMLElement && (target.isContentEditable || target.closest('input, textarea, select')))
            return;
        if (handler(event)) event.stopImmediatePropagation();
    };
    const suppressRelease = (event: MouseEvent) => {
        if (!pressed || event.button !== button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (event.type === 'auxclick') pressed = false;
    };
    document.addEventListener('mousedown', onMouseDown, capture);
    document.addEventListener('mouseup', suppressRelease, true);
    document.addEventListener('auxclick', suppressRelease, true);
    return () => {
        document.removeEventListener('mousedown', onMouseDown, capture);
        document.removeEventListener('mouseup', suppressRelease, true);
        document.removeEventListener('auxclick', suppressRelease, true);
        releaseGuard();
    };
}
